import { render, staticRenderFns } from "./CategoryMenuGroupSidebar.vue?vue&type=template&id=e47fa97a&scoped=true"
import script from "./CategoryMenuGroupSidebar.vue?vue&type=script&lang=js"
export * from "./CategoryMenuGroupSidebar.vue?vue&type=script&lang=js"
import style0 from "./CategoryMenuGroupSidebar.vue?vue&type=style&index=0&id=e47fa97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47fa97a",
  null
  
)

export default component.exports